import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            {contactData.title}
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-10 text-center">
            <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-100/80 text-accent-500">
              <i className="ri-mail-send-line text-2xl"></i>
            </div>

            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto">
              {contactData.description}
            </p>

            <div className="inline-flex items-center gap-2 px-5 py-3 bg-background-100/70 rounded-lg">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
            </div>

            <p className="mt-4 text-xs text-foreground-500">{contactData.hint}</p>
          </div>
        </div>
      </div>
    </section>
  );
}